module.exports = {"es-PY":{"table-header":{"actions":"Acciones"}}}